// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"40145a37","703":"32c19adf"}[chunkId] + ".chunk.js";
};